import { combineReducers } from "redux";
// import welcomes from "../features/admin/aboutus/welcomes/Slice";
import turntable_spin from "../features/spins/turntable_spin/Slice";


const spins = combineReducers({
    turntable_spin: turntable_spin,
});

export default spins;